exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input:-webkit-autofill{box-shadow:inset 0 0 0 100px #fff}.v-application .ma-1{margin:1px!important}", ""]);

// exports
